/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiDynamicExportDefinition, ApiDynamicExportOption, CreateExportDefinitionFromAiRequest, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of DynamicExportDefinitionController.
 */
export class DynamicExportDefinitionRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /export_definitions:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiDynamicExportDefinition>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiDynamicExportDefinition>>>('/export_definitions:query', query);
    }

    /**
     * Calls POST /export_definitions:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiDynamicExportDefinition>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiDynamicExportDefinition>>, ListRequest>('/export_definitions:query', listRequest, query);
    }

    /**
     * Calls POST /export_definitions:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiDynamicExportDefinition>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiDynamicExportDefinition>>, ListRequestWithIds>('/export_definitions:batch', listRequest, query);
    }

    /**
     * Calls POST /export_definitions:prefill
     */
    public createPrefilled(): Promise<Result<ApiDynamicExportDefinition>> {
        return this.http.post<Result<ApiDynamicExportDefinition>, undefined>('/export_definitions:prefill', undefined);
    }

    /**
     * Calls POST /export_definitions:generate
     */
    public generateDynamicExportFromAi(request: CreateExportDefinitionFromAiRequest): Promise<Result<ApiDynamicExportDefinition>> {
        return this.http.post<Result<ApiDynamicExportDefinition>, CreateExportDefinitionFromAiRequest>('/export_definitions:generate', request);
    }

    /**
     * Calls POST /export_definitions/options/{exportCategory}
     */
    public availableDynamicExports(exportCategory: string, exportKey: string | undefined): Promise<Result<ApiDynamicExportOption[]>> {
        const query = new URLSearchParams();
        if (exportKey !== undefined) {
            query.set('exportKey', `${exportKey}`);
        }

        return this.http.post<Result<ApiDynamicExportOption[]>, undefined>(`/export_definitions/options/${exportCategory}`, undefined, query);
    }

    /**
     * Calls POST /export_definitions/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiDynamicExportDefinition>>> {
        return this.http.post<Result<LockedContextDto<ApiDynamicExportDefinition>>, undefined>(`/export_definitions/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /export_definitions/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiDynamicExportDefinition>> {
        return this.http.post<Result<ApiDynamicExportDefinition>, undefined>(`/export_definitions/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /export_definitions/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiDynamicExportDefinition[]>> {
        return this.http.post<Result<ApiDynamicExportDefinition[]>, string[]>('/export_definitions/locks', ids);
    }

    /**
     * Calls POST /export_definitions/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/export_definitions/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /export_definitions/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/export_definitions/${primaryId}/locks`);
    }

    /**
     * Calls GET /export_definitions/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiDynamicExportDefinition>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiDynamicExportDefinition>>(`/export_definitions/${primaryId}`, query);
    }

    /**
     * Calls POST /export_definitions
     */
    public add(dto: ApiDynamicExportDefinition): Promise<Result<ApiDynamicExportDefinition>> {
        return this.http.post<Result<ApiDynamicExportDefinition>, ApiDynamicExportDefinition>('/export_definitions', dto);
    }

    /**
     * Calls PUT /export_definitions/{primaryId}
     */
    public update(dto: ApiDynamicExportDefinition, primaryId: string): Promise<Result<ApiDynamicExportDefinition>> {
        return this.http.put<Result<ApiDynamicExportDefinition>, ApiDynamicExportDefinition>(`/export_definitions/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /export_definitions
     */
    public putRange(dtos: ApiDynamicExportDefinition[]): Promise<Result<ApiDynamicExportDefinition[]>> {
        return this.http.patch<Result<ApiDynamicExportDefinition[]>, ApiDynamicExportDefinition[]>('/export_definitions', dtos);
    }

    /**
     * Calls DELETE /export_definitions/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/export_definitions/${primaryId}`);
    }
}
